let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9mAAJ")).then(() => parcelRequire('j6Qxa'));